import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * Native theme cart drawer.
 *
 * The native drawer is intentionally prevented from opening because
 * UpCart is being used as the store's cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();

    /**
     * We intentionally do NOT listen for CartAddEvent here.
     * UpCart handles the cart after a product is added.
     */
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  /**
   * Prevent the theme's native cart drawer from opening.
   *
   * The cart trigger itself remains in the DOM so UpCart can still
   * detect/intercept cart interactions.
   */
  open() {
    return;
  }

  /**
   * Keep the close method available in case the component is referenced
   * elsewhere by the theme.
   */
  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}